/**
 * Feature Flags
 *
 * To enable/disable a feature, change `enabled` here.
 * All areas (template selector, service settings, workflow actions) update automatically.
 *
 * To add a new gated feature:
 *   1. Add an entry in `featureFlags`
 *   2. Add its identifier(s) in the relevant mapping tables below
 */

export interface FeatureFlag {
  enabled: boolean;
  comingSoon?: boolean;
}

// ─── Feature definitions ────────────────────────────────────────────────────────

const featureFlags: Record<string, FeatureFlag> = {
  whatsapp: { enabled: false, comingSoon: true },
  richtexting: { enabled: false, comingSoon: true },
};

// ─── Mapping tables (area identifier → feature key) ─────────────────────────────

// Template types (values from TemplateTypeEnum)
const templateTypeToFeature: Record<string, string> = {
  whatsapp: 'whatsapp',
  richtexting: 'richtexting',
};

// Service parameter names (from NewServicesParameters serviceGroups)
const serviceToFeature: Record<string, string> = {
  whatsapp_business: 'whatsapp',
  rcs: 'richtexting',
};

// Workflow operator IDs (from *Metadata.ts Meta.id)
const operatorToFeature: Record<string, string> = {
  boxsendwhatsapp: 'whatsapp',
  boxsendrcs: 'richtexting',
};

// ─── Generic helpers ────────────────────────────────────────────────────────────

export const getFeatureFlagForTemplateType = (type: string): FeatureFlag | null => {
  const key = templateTypeToFeature[type];
  return key ? featureFlags[key] ?? null : null;
};

export const getFeatureFlagForService = (name: string): FeatureFlag | null => {
  const key = serviceToFeature[name];
  return key ? featureFlags[key] ?? null : null;
};

export const getFeatureFlagForOperator = (id: string): FeatureFlag | null => {
  const key = operatorToFeature[id];
  return key ? featureFlags[key] ?? null : null;
};
